import { type TFunction } from 'i18next';
import { type SessionWillEndSoonMessageKey } from './SessionWillEndSoonMessage.types';

export const getMessages = (t: TFunction): Record<SessionWillEndSoonMessageKey, React.ReactNode> => ({
    yourSessionWillEnd: (
        <p>
            ⏰ <span className="font-semibold">{t('headsUp')}</span> {t('yourSessionWillEnd')}
        </p>
    ),
    wrapThingsUp: <p>⏰ {t('wrapThingsUp')}</p>,
});
